import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { IsApplicationService } from '../../../../core/services/is-application.service';
import { LanguageService } from '../../../../core/services/language.service';

import { supportedScroll } from '../../../../shared/utils/scroll';

@Component({
  selector: 'app-public-top-nav',
  templateUrl: './public-top-nav.component.html',
  styleUrls: ['./public-top-nav.component.scss'],
})
export class PublicTopNavComponent implements OnInit {
  buttonsState = 'close';

  @Input() fullWidthNav: boolean;

  constructor(
    protected router: Router,
    public isApplicationService: IsApplicationService,
    public languageService: LanguageService
  ) {}

  ngOnInit() {}

  scrollToLanding(section) {
    this.buttonsState = 'close';
    setTimeout(() => {
      const sectionToScroll = document.getElementById(section);
      if (
        (this.router.url === '/' ||
          this.router.url.indexOf('home/') !== -1 ||
          this.router.url.indexOf('pae') !== -1) &&
        sectionToScroll
      ) {
        const offset = document.getElementById('navbarContainer').clientHeight;
        supportedScroll(window, sectionToScroll.offsetTop - offset);
      } else {
        this.router.navigate(['home/' + section]);
      }
    });
  }

  scrollToTop() {
    supportedScroll(window, 0);
  }

  toggleButtonsState() {
    if (this.buttonsState === 'close') {
      this.buttonsState = 'open';
    } else {
      this.buttonsState = 'close';
    }
  }
}
